// import React, { useState } from "react";
// import { Button, Form, Input, Modal } from "antd";
// import axios from "axios";
// import { eramanApiURL } from "~/Utils";
// import RichTextEditor from "../Richtext/Richtext";

// interface EmailTemplateProps {
//   visible: boolean;
//   onClose: () => void;
//   recipientEmail: string; 
//   onSubmit: (values: { email: string; subject: string; message: string }) => void;
//   subjectContent?: string;
//   title: string;
// }

// export const EmailTemplate: React.FC<EmailTemplateProps> = ({
//   visible,
//   onClose,
//   recipientEmail,
//   onSubmit,
//   subjectContent,
//   title
// }) => {
//     console.log("emailTemplate", visible, recipientEmail);
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (values: { email: string; subject: string; message: string }) => {
//     setLoading(true);
//     try {
//     //   await axios.post(`${eramanApiURL}/admin/send-email`, {
//     //     to: values.email,
//     //     subject: values.subject,
//     //     message: values.message,
//     //   });
//       onSubmit(values);
//       form.resetFields();
//       onClose();
//     } catch (error) {
//       console.error("Error sending email:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal
//       title={title}
//       visible={visible}
//       onCancel={onClose}
//       footer={null}
//       width={800}
//     >
//       <Form
//         form={form}
//         layout="vertical"
//         initialValues={{ email: recipientEmail,subject: subjectContent }}
//         onFinish={handleSubmit}
//       >
//         <Form.Item
//           label="Email"
//           name="email"
//           rules={[{ required: true, message: "Please enter the recipient's email" }, { type: "email", message: "Please enter a valid email" }]}
//         >
//           <Input placeholder="Recipient's email" disabled={!!recipientEmail} />
//         </Form.Item>

//         <Form.Item
//           label="Subject"
//           name="subject"
//           rules={[{ required: true, message: "Please enter the email subject" }]}
//         >
//           <Input 
//             placeholder="Email subject" 
//             disabled={!!subjectContent} 
//             value={subjectContent} 
//           />
//         </Form.Item>

//         <Form.Item
//           label="Message"
//           name="message"
//           rules={[{ required: true, message: "Please enter the message" }]}
//         >
//           <RichTextEditor
//             value={form.getFieldValue("message") || ""}
//             onChange={(value) => form.setFieldsValue({ message: value })}
//             placeholder="Enter your message here..."
//           />
//         </Form.Item>

//         <Form.Item>
//           <div className="flex justify-end gap-2">
//             <Button onClick={onClose}>Cancel</Button>
//             <Button type="primary" htmlType="submit" loading={loading}>
//               Send Email
//             </Button>
//           </div>
//         </Form.Item>
//       </Form>
//     </Modal>
//   );
// };

import React, { useState, useEffect } from "react";
import { Button, Form, Input, Modal } from "antd";
import { Controller, useForm } from "react-hook-form";
import { Icon } from "@iconify/react";
import RichTextEditor from "../Richtext/Richtext";
import { FieldValues } from "react-hook-form";
import { FieldConfig, FormConfig } from "../DynamicForm/DynamicForm";

interface EmailTemplateProps {
  visible: boolean;
  onClose: () => void;
  recipientEmail: string;
  onSubmit?: (data: FieldValues) => void;
  subjectContent?: string;
  title: string;
  formConfig: FormConfig;
}

export const EmailTemplate: React.FC<EmailTemplateProps> = ({
  visible,
  onClose,
  recipientEmail,
  onSubmit,
  subjectContent,
  title,
  formConfig
}) => {
  const [loading, setLoading] = useState(false);
  console.log("emailtemplageeee", formConfig.fields, formConfig.initialValues);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues:formConfig.initialValues 
  });

  useEffect(() => {
    reset(formConfig.initialValues);
  }, [formConfig.initialValues, reset]);

  const renderField = (field: FieldConfig) => {
    switch (field.type) {
      case "input":
        return (
          <Controller
            name={field.name}
            control={control}
            rules={field.validation}
            render={({ field: controllerField }: { field: FieldValues }) => {
                console.log("theformused", controllerField);
                return(
                    <Input
                    value={controllerField.value || ""} 
                    onChange={(e) => controllerField.onChange(e.target.value)} 
                    placeholder={field.placeholder}
                    disabled={field.editable === false}
                    className="h-10"
                  />
            )}}
          />
        );
      case "richText":
        return (
          <Controller
            name={field.name}
            control={control}
            rules={field.validation}
            render={({ field: controllerField }) => (
              <RichTextEditor
                value={controllerField.value || ""}
                onChange={controllerField.onChange}
                placeholder={field.placeholder}
              />
            )}
          />
        );
      default:
        return null;
    }
  };

  const handleFormSubmit = async (data: FieldValues) => {
    setLoading(true);
    try {
      onSubmit(data);
      reset(); 
      onClose();
    } catch (error) {
      console.error("Error sending email:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Form
        className="grid grid-cols-12 gap-4 w-full"
        layout="vertical"
        onFinish={handleSubmit(handleFormSubmit)}
      >
        {formConfig.fields.map((field) => {
          const isRequired = Boolean(field.validation?.required);
          return (
            <Form.Item
              className="col-span-12"
              key={field.name}
              label={field.label}
              required={isRequired}
              validateStatus={errors[field.name] ? "error" : ""}
              help={errors[field.name]?.message?.toString()}
            >
              {renderField(field)}
            </Form.Item>
          );
        })}

        <Form.Item className="col-span-12">
          <div className="flex justify-end gap-2">
            <Button onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              icon={<Icon icon="mdi:send" />}
            >
              Send Email
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};